import { ReduxStore } from 'store/types';

function getAllIsLoading(state: ReduxStore): boolean {
  return state.manufacturer.getAll.config.isLoading;
}

export default getAllIsLoading;
